import { render, staticRenderFns } from "./TagsSearchBar.vue?vue&type=template&id=9f5b7d5a&scoped=true"
import script from "./TagsSearchBar.vue?vue&type=script&lang=js"
export * from "./TagsSearchBar.vue?vue&type=script&lang=js"
import style0 from "./TagsSearchBar.vue?vue&type=style&index=0&id=9f5b7d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5b7d5a",
  null
  
)

export default component.exports